<div
  class="card widget-1 h-100"
  [class.clickable]="tag.click"
  (click)="onClick()"
>
  <div
    class="card-body {{ randomSvgColor }} min-vh-50"
    [ngClass]="{
      'd-flex justify-content-center align-items-center text-center':
        tag.title === 'GGR',
      'd-flex flex-column align-items-start justify-content-start text-start':
        tag.title !== 'GGR'
    }"
  >
    <div class="widget-content d-flex align-items-center gap-2 w-100">
      <div class="bg-gradient">
        <svg class="svg-fill">
          <use
            attr.xlink:href="assets/svg/icon-sprite.svg#{{ tag.icon }}"
          ></use>
        </svg>
        <svg class="half-circle">
          <use href="assets/svg/icon-sprite.svg#halfcircle"></use>
        </svg>
      </div>

      <div class="d-flex flex-column">
        @if (isLoading) {
        <div class="skeleton text-skeleton rounded-3"></div>
        } @else {
        <div>
          <h4>
            @switch (format) { @case ('currency') {
            {{
              tag.price
                | currency
                  : currencyCode
                  : 'symbol'
                  : FORMAT_FOR_CURRENCY_DIGITS
            }}
            } @case ('decimal') {
            {{ tag.price | number : FORMAT_FOR_NUMBER_DIGITS }}
            } @default {
            {{ tag.price | number : FORMAT_FOR_INTEGER }}
            } }
          </h4>

          <span class="f-light">{{ tag.title | translate }}</span>
        </div>
        }
        <span class="f-12 f-w-500 font-{{ tag.colorClass }}">
          <span class="f-light"> {{ tag.growth }}</span>
        </span>
      </div>
    </div>

    @if (tag.click) {
    <div class="click-arrow">
      <i class="fa fa-arrow-right"></i>
    </div>
    }
  </div>
</div>
